module.exports = __webpack_public_path__ + "static/media/bill_info.2ce915c3.svg";